import axios from 'axios'

const apiUrl = '/api'

export const getFormToken = () => {
  return axios.get(`${apiUrl}/token`)
}

export const sendTG = formData => {
  const baseUrl = `${apiUrl}/sendtg`
  return axios.post(baseUrl, formData)
}
